import React, { useMemo } from 'react';
import { Box, ShimmerBox } from '@common-fe/common-fe';
import styled from 'styled-components';

import { Dashboard } from '@/modules/core';
import Banners from '@/modules/core/components/Banners/Banners';
import TopBar, { TopBarShimmerBox } from '@/modules/core/components/Topbar/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { useGetReportPreferencesQuery } from '@/modules/Reports/queries';
import { useAuthStore } from '@/modules/user/stores';
import theme from '@/styles/theme';

const Wrapper = styled(Box)`
  display: block;
`;

const WelcomeShimmerBox = () => <ShimmerBox height="258px" round="moduleRound" />;


export const Home: React.FC = () => {
  useBreadcrumbs([]);
  useGetReportPreferencesQuery();
  const { user } = useAuthStore();

  const isLoading = useMemo(() => !user, [user]);

  return (
    <Wrapper pad={{ top: '0' }} width="100%" {...(isLoading ? { overflow: 'hidden' } : {})}>
      {isLoading ? <TopBarShimmerBox /> : <TopBar showToolbarButtons />}
      <Box pad={{ horizontal: '40px', vertical: '40px' }} align="center">
        <Box width={theme.defaultContentWidth} gap="spacing24">
          {isLoading ? <WelcomeShimmerBox /> : <Dashboard bannerNode={<Banners />}></Dashboard>}
        </Box>
      </Box>
    </Wrapper>
  );
};
